import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import moment from 'moment';
import { PICKER_DATE_MASK } from 'shared/constants';
import { ICreateFAQ } from 'shared/types/faq.types';

const initialState: ICreateFAQ[] = [];

export const faqSlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    faq: (state, { payload }: PayloadAction<ICreateFAQ>) => {
      const now = moment();
      const withCreatedDate = { ...payload, created: now.format(PICKER_DATE_MASK), id: Math.random() * 100000 };
      state.push(withCreatedDate);
    },
  },
});

const faq = (state: RootState) => state.entities.faq;
const getOrganizations = createSelector(faq, state => state);

export const selectors = { getOrganizations };
export const faqActions = faqSlice.actions;
export const reducer = faqSlice.reducer;
